module.exports = __webpack_public_path__ + "7cf851dc7916c2ea82aa90f9add108c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/illustrations_05.png
// module id = 935
// module chunks = 3